import { render, staticRenderFns } from "./ReminderStatus.vue?vue&type=template&id=870fa996"
import script from "./ReminderStatus.vue?vue&type=script&lang=ts"
export * from "./ReminderStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports